<template>
	<iframe :src="url" id="iframe"></iframe>
    <!-- <div class="invite_wrap">
    	<div class="basic_wrap">
    		<div class="red_top_bg">
    			<div class="back_left" @click="$router.back()"></div>
    			<div class="big_tit">{{$t('webindex.custserver')}}</div>
    			<div class="back_right" @click="$router.push('/user')">
					<img src="../images/user/my.png">
				</div>
    			<div class="introduce">
    			    <div class="line left_line"></div>
    			    <div class="tit">{{$t('webindex.custwaiting')}}</div>
    			    <div class="line right_line"></div>
    			</div>
    			<div class="award_tip">
    				{{$t('webindex.worktime')}}
    			</div>
    		</div>
			
			<div v-if="data" class="user_top">
				<ul class="connect">
			
					<li>
						<div class="left">
							<i class="whatsapp"></i>
							<div>
								<p>Whatsapp</p>
								<p></p>
							</div>
						</div>
						<a :href="data.kefu_link" target="_blank">
							<div class="consult">{{$t('webindex.chat')}}</div>
						</a>
					</li>
				</ul>
			</div>
		</div>	
    </div> -->
</template>

<script>
    import Fetch from '../../utils/fetch'

    export default {
        name: "kefu",
        components: {},
        data() {
            return {
                handler:null,
				url:'javascript:void(0)',
                data: {}
            };
        },
        created() {
            this.$parent.footer('moneybag',true);
        },
        mounted() {
			
            this.start();
        },
        methods: {
            start() {
				Fetch('/index/webconfig').then(res => {
				    if(res && res.data && res.data.kefu_link){
						var url = res.data.kefu_link;
						if(url){
							Fetch('/user/info').then((r) => {
								this.data = r.data;
								if(r && r.data){
									this.url = url+'&visiter_id='+parseInt(100*r.data.uid)+'&visiter_name='+r.data.name+'('+r.data.beiname+')'+r.data.mobile;
								}
							});
						}else{
							this.url = url;
						}
					}
				})
            },
        }
    };
</script>

<style lang="less" scoped>

    .red_top_bg {
    	height: auto;
		padding-bottom: 20px;
    	.big_tit {
    		position: absolute;
    	}
    	.back_right{
    		position: absolute;
    		top: 3px;
    		right: 3px;
			img{
				height: 35px;
				margin: 5px;
			}
    	}
    	.introduce {
    	    height: 25px;
    	    display: flex;
    	    justify-content: center;
    	    align-items: center;
    	    font-size: 18px;
    	    line-height: 25px;
    	    color: #FFFFFF;
    	    margin-top: 20px;
    	
    	    .line {
    	        width: 36px;
    	        height: 10px;
    	    }
    	
    	    .tit {
    	        margin: 0 12px;
    	        font-weight: bold;
    	    }
    	
    	    .left_line {
    	        background: url(../images/user/left_icon.png) no-repeat center center;
    	        background-size: 100% 100%;
    	    }
    	
    	    .right_line {
    	        background: url(../images/user/right_icon.png) no-repeat center center;
    	        background-size: 100% 100%;
    	    }
    	}
    	.award_tip {
    	    font-size: 14px;
    	    line-height: 25px;
    	    color: rgba(255, 255, 255, 0.8);
    	    text-align: center;
    	    margin: 3px auto 0 auto;
			padding: 5px 25px;
    	}
    }
	.user_top{
		background: #FFFFFF;
		border-radius: 5px;
		padding: 15px 0;
		margin: 10px;
		.user_detail{
			display: flex;
			justify-content: space-between;
			text-align: center;
			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				border-radius: 50%;
				position: absolute;
				top: -35px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			span{
				margin-left: 85px;
				font-size: 16px;
				font-weight: bold;
			}
		}
		.user_balance{
			text-align: center;
			margin-top: 20px;
			p:nth-child(1){
				font-size: 14px;
			}
			p:nth-child(2){
				margin-top: 10px;
				font-weight: bold;
				font-size: 18px;
				color: #FF0000;
			}
		}
		.user_team{
			display: flex;
			justify-content: space-between;
			text-align: center;
			p{
				width: 50%;
				margin-top: 20px;
				font-size: 14px;
			}
			p:nth-child(1){
				border-right: 1px #999 solid;
			}
			span{
				color: #FF0000;
				font-weight: bold;
			}
			
		}
		.user_share{
			display: flex;
			justify-content: space-between;
			margin: 20px 0 0px 0;
			font-size: 14px;
			p:nth-child(1){
				width: 70%;
				margin-left: 20px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				line-height: 28px;
			}
			p:nth-child(2){
				text-align: center;
				width: 20%;
				background: #e7544d;
				color: #FFFFFF;
				padding: 6px 0px;
				border-radius: 5px;
				margin-right: 15px;
			}
		}
	}
	.user_top ul{
		min-width: 96%;
	}
	.user_top ul{
		min-width: 96%;
		/*padding: 21px;*/
		border-radius:12px;
		margin: 0px;
		/*background: #020304;*/
	}
	.user_top ul li {
		list-style: none;
		margin: 21px auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #FFF;
		padding: 11px;
		width: 300px;
		border-radius: 5px;
		border: 1px solid #ccc;
	}
	.user_top ul li .left {
		display: flex;
		align-items: center;
	}
	.user_top ul li .left .contract{
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABRCAMAAACdUboEAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANtBLioAAAAQdFJOUwDxTSaMEuAYBgzPpHo2umMzXzYbAAACWUlEQVRYw7WZ27bqIAxF5dIm3Pn/r91g9ZxiJVCBPFWHnV1JwIT08WgbojoM8TFsqLYNCtvUABY/YP+p+Js6oOy+Upr3ZE7m3WNW4/drPBX0W49MhHuGMwV2ydzgvm0zUtKbIIRfDSe6TDr+O7CCVDBiamYQa6GEUZvr8xe/EcYN7+TZcSll4KI/36TPzuzxZTqITr+JnwmTSSZplD6Rme1KTl3ixvfIpANujZFB8IQ3HSKJtHAWtXNZZsyu+5CeYNrJIaKo0/32iOERTCM0gVTNKMqowcQzMe5JNm9Esu60i8zZWBKjt+kxtNv1tWiihPhJjFzXRW600yIywa9EaaMn3UYiinuwV6IGlrQTbtcznRi7uRJZ1h2IbNfDyPJqqRAlEUhqMaY7r8SdIgJJ9OnOb3FsEJHWGK5EQxKRIiaNTFyJNhNtnUhsaq53+xRaEh0Y5kV9a7cKzHUXtspNiyjYBzGMEkGWRA3DxHckX0Q+gejYiWhhAjGXhjdRdjQCPbXf+YO4h54+oIcoBJdem5AuejqLNk8yfZCEZrLFbDdliZfXjMvO56y3mK2W5+A9/xRfCWowN7paO8P+/VEwcbo2jqrY1dQIH0/GgJ0/eqq8trbfG1E8oLYyqXotCk1ps9hYaq7X64rboQCk/czLLwLRSlX2niwsh6EwTnSQ4139Z2+G04j4mCxSTTweXQ5JarbEsXPr9/Pr/DPX/HPhgrPrgvP1/BnAgjnFglnKgnnP/JnUgrnZitnegvnjghnpijnuglnzinn4ipn9gvcKS959FO9noPf9zB/S1p0EWCZ5GQAAAABJRU5ErkJggg==) 50% no-repeat;
		background-size: contain;
	}
	.user_top ul li .left p:first-child {
		font-size: 14px;
		color: #000;
		font-weight: 700;
		/*margin-bottom: 5px;*/
	}
	a {
		text-decoration: none;
	}
	.user_top ul li .consult {
		width: 64px;
		padding: 5px;
		background:#36333d;
		border-radius: 18px;
		color: #FFFFFF;
		text-align: center;
		font-size: 12px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.user_top ul li .left i{
		display: inline-block;
		width: 43px;
		height: 43px;
		margin-right: 9px;
	}
	.user_top ul li .left .telegram{
		background: url(data:image/png;base64,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) 50% no-repeat;
		background-size: contain;
	}
	.user_top ul li .left .qq {
		background: url(data:image/png;base64,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) 50% no-repeat;
		background-size: contain;
	}
	.user_top ul li .left .wechat{
		background: url(data:image/png;base64,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) 50% no-repeat;
		background-size: contain;
	}
	.user_top ul li .left .whatsapp {
		background: url(data:image/png;base64,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) 50% no-repeat;
		background-size: contain;
	}
	.user_top ul li .left .line {
		background: url(data:image/png;base64,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) 50% no-repeat;
		background-size: contain;
	}
	#iframe {
	    width: 100%;
		height: 100vh;
	    // height: calc(100vh - 60px);
	    overflow-y: scroll;
	    border: none;
		padding-bottom: 60px;
	}
</style>


